export const resetUser = (state) => {
  state.status = '';
  state.user = {};
  state.userStatus = '';
  state.addUserContactStatus = '';
  state.createUserContactStatus = '';
  state.deleteUserContactStatus = '';
  state.userContacts = [];
  state.userSelectedContacts = [];
  state.finalUserSelectedContacts = [];
  state.eventContacts = [];
  state.eventSelectedContacts = [];
  state.finalEventSelectedContacts = [];
  state.error = '';
  state.searchContactStatus = '';
  state.searchContact = {};
  state.searchContactError = '';
};
